import React from 'react';

const Canada1 = () => {
  return (
    <div>
      
    </div>
  );
}

export default Canada1;
